import { z } from 'zod';
import { Item } from './item.js';
export const CategoryKind = z.enum(['income', 'fast', 'variabel', 'opsparing']);
export const Category = z.object({
    id: z.number().int(),
    name: z.string().min(1).max(120),
    kind: CategoryKind,
    source_label: z.string().max(60).nullable(),
    sort_order: z.number().int(),
    items: z.array(Item),
});
export const CreateCategoryRequest = z.object({
    name: z.string().min(1).max(120),
    kind: CategoryKind,
    source_label: z.string().max(60).nullable().optional(),
    sort_order: z.number().int().optional(),
});
export const UpdateCategoryRequest = z
    .object({
    name: z.string().min(1).max(120).optional(),
    source_label: z.string().max(60).nullable().optional(),
    sort_order: z.number().int().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
